import { Component } from '@angular/core';

@Component({
  selector: 'app-new-roof-cost-header',
  standalone: true,
  templateUrl: './new-roof-cost-header.component.html',
  styleUrl: './new-roof-cost-header.component.scss',
})
export class NewRoofCostHeaderComponent {}
